<template>
  <div id="apppurchaseconfirmation">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <TeacherPurchaseConfirmation />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import TeacherPurchaseConfirmation from "@/components/app-components/teacher/TeacherPurchaseConfirmation.vue";

export default {
  name: "AppPurchaseConfirmationView",
  components: { TeacherPurchaseConfirmation },
  data: () => ({}),
};
</script>